/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { TermsDto } from '../../models/terms-dto';

export interface TermsControllerGetByTypeAndVersion$Params {
  version: string;
  type: 'SERVICE' | 'PRIVACY' | 'INVESTMENT' | 'THIRD_PARTY' | 'MARKETING' | 'ASSET';
}

export function termsControllerGetByTypeAndVersion(http: HttpClient, rootUrl: string, params: TermsControllerGetByTypeAndVersion$Params, context?: HttpContext): Observable<StrictHttpResponse<TermsDto>> {
  const rb = new RequestBuilder(rootUrl, termsControllerGetByTypeAndVersion.PATH, 'get');
  if (params) {
    rb.path('version', params.version, {});
    rb.path('type', params.type, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<TermsDto>;
    })
  );
}

termsControllerGetByTypeAndVersion.PATH = '/api/terms/{type}/version/{version}';
